import React from "react";
import "../../styles/user_profile/user_profile.css";

function getInitials(name) {
    if (!name) return "UU";

    const cleaned = name.trim().replace(/[-._]/g, " ");
    const parts = cleaned.split(" ").filter(Boolean);

    if (parts.length === 1) return parts[0][0].toUpperCase();

    return (parts[0][0] + parts[1][0]).toUpperCase();
}

function stringToColor(str, currentUser) {
    // If this is the current user, always return dark blue
    if (str === currentUser) {
        return '#004282'; // Dark Blue
    }

    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash; // Convert to 32bit integer
    }

    // Normal (bright) color palette for others
    const colors = [
        { h: 210, s: 70, l: 50 }, // Blue
        { h: 120, s: 60, l: 50 }, // Green
        { h: 30, s: 80, l: 50 }   // Orange
    ];

    const index = Math.abs(hash) % colors.length;
    const { h, s, l } = colors[index];

    return `hsl(${h}, ${s}%, ${l}%)`;
}

const ProfileAvatar = ({ user, active, currentUser }) => {
    const username = user?.userName || user?.username || "";
    const initials = getInitials(username);
    const avatarUrl = user?.avatarUrl;
    const bgColor = stringToColor(username, currentUser);

    return (
        <div className="profile-container">
            {avatarUrl ? (
                <img src={avatarUrl} alt="User Avatar" className="avatar-image" />
            ) : (
                <div
                    className={`avatar-placeholder ${active ? "active" : ""}`}
                    style={{ backgroundColor: bgColor }}
                >
                    {initials}
                </div>
            )}
        </div>
    );
};

export default ProfileAvatar;
